import type { MRT_ColumnDef } from "mantine-react-table";

import { createDateColumn, createStringColumn } from "../MetadataDocuments/columns/columnHelpers";
import { createUrlActionsColumn } from "../MetadataDocuments/columns/linkColumnHelper";
import type { TripAnalyzerSchema } from "./types";

const namespace = "tripanalyzer";

export const formatDateTimeForCell = (value: Date | undefined): string => {
    if (!value) return "N/A";
    return value.toLocaleString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const tripAnalyzerColumns: MRT_ColumnDef<TripAnalyzerSchema>[] = [
    createUrlActionsColumn<TripAnalyzerSchema>({
        namespace,
        urlFields: ["source"],
    }),
    createDateColumn<TripAnalyzerSchema>({
        namespace,
        field: "timestamp",
        header: "Timestamp",
        accessor: (row) => row?._source?.timestamp,
        overrides: {
            accessorKey: "_source.timestamp",
            accessorFn: (row) => {
                const value = row?._source?.timestamp;
                if (!value) return undefined;
                const date = new Date(value);
                return Number.isNaN(date.getTime()) ? undefined : date;
            },
            Cell: ({ cell }) => formatDateTimeForCell(cell.getValue<Date | undefined>()),
        },
    }),
    createStringColumn<TripAnalyzerSchema>({
        namespace,
        field: "machine",
        header: "Machine",
        accessor: (row) => row?._source?.machine ?? "",
        overrides: {
            accessorKey: "_source.machine",
        },
    }),
    createStringColumn<TripAnalyzerSchema>({
        namespace,
        field: "summary",
        header: "Summary",
        accessor: (row) => row?._source?.summary ?? "",
        overrides: {
            accessorKey: "_source.summary",
            size: 500,
        },
    }),
];
